import React, { useState } from "react";
import { Crown, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const DISMISS_KEY = "kora_premium_expiry_dismiss";
const HIDDEN_PATHS = ["/", "/premium", "/onboarding", "/verification", "/premium/retour"];

export const PremiumExpiryBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === "1");

  if (!user || !user.premium || !user.premium_until || dismissed) return null;
  if (HIDDEN_PATHS.includes(pathname) || pathname.startsWith("/chat/") || pathname.startsWith("/call/")) return null;

  const diffMs = new Date(user.premium_until).getTime() - Date.now();
  const daysLeft = Math.ceil(diffMs / 86400000);
  if (daysLeft > 3) return null;

  const label =
    daysLeft >= 2
      ? `Votre Premium expire dans ${daysLeft} jours`
      : daysLeft === 1
      ? "Votre Premium expire demain"
      : "Votre Premium expire aujourd'hui";

  return (
    <div
      data-testid="premium-expiry-banner"
      className="sticky top-0 z-[60] flex items-center justify-center gap-2 sm:gap-3 px-3 py-2.5 bg-gradient-to-r from-amber-500 via-orange-500 to-kora-terracotta text-white shadow-md"
    >
      <Crown size={18} className="shrink-0" />
      <p data-testid="premium-expiry-banner-text" className="text-sm font-medium leading-snug">
        {label} — ne perdez pas vos avantages !
      </p>
      <button
        data-testid="premium-expiry-banner-renew-btn"
        onClick={() => navigate("/premium")}
        className="shrink-0 px-3 py-1 rounded-full bg-white text-orange-600 text-sm font-semibold hover:bg-orange-50 transition-colors"
      >
        Renouveler
      </button>
      <button
        data-testid="premium-expiry-banner-close-btn"
        aria-label="Fermer"
        onClick={() => {
          sessionStorage.setItem(DISMISS_KEY, "1");
          setDismissed(true);
        }}
        className="shrink-0 p-1 rounded-full hover:bg-white/20 transition-colors"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default PremiumExpiryBanner;
